import React from 'react';

const initialState = {
   display: 'none',
   children: null,
   extraProps: {
      bgcolor: 'secondary.main',
      boxShadow: 3,
      color: 'text.primary',
      position: 'fixed',
      zIndex: 'drawer',
      bottom: 0,
      left: '15%',
      p: 1
   }
};

const sliceConfig = {
   name: 'overlay',
   initialState: initialState,
   reducers: {
      close(state) {
         state.display = initialState.display;
         state.children = initialState.children;
         state.extraProps = initialState.extraProps;
      },
      open(state, action) {
         state.extraProps = {
            ...initialState.extraProps,
            ...action.payload.extraProps
         };
         state.display = 'block';
         state.children = action.payload.children;
      }
   }
};

const Close = 'overlay/close';
const Open = 'overlay/open';
const OpenMsg = 'msg/open';

export function open(Component, componentProps = {}, callbackOnClose = null, containerProps = {}) {
   return async function (dispatch) {
      const {display, zIndex, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               dispatch({type: Close});
            } else {
               dispatch({type: Close});
            }
         } catch (error) {
            //dispatch(openMsg(dev.getErrorMsg(error)));
            dispatch({
               type: OpenMsg,
               payload: {
                  mensaje: error.toString(),
                  accionAceptar: null,
                  aceptarLabel: 'Eliminar'
               }
            });
         }
      }
      function handleOnClose() {
         dispatch({
            type: Close
         });
      }
      dispatch({
         type: Open,
         payload: {
            extraProps: {
               ...options
            },
            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={handleOnClose}
                  {...componentProps}
               />
            )
         }
      });
   };
}

export default sliceConfig;
